"use client";

import { useRef } from "react";

export const useDebounce = <TProps extends any[] = any[], TReturn = void>(
  callback: (...props: TProps) => Promise<TReturn>,
  timeMs: number = 200,
): ((...props: TProps) => Promise<TReturn>) => {
  const timeout = useRef<NodeJS.Timeout | null>(null);

  return (...props: TProps) => {
    if (timeout.current) clearTimeout(timeout.current);
    return new Promise<TReturn>((resolve) => {
      timeout.current = setTimeout(() => resolve(callback(...props)), timeMs);
    });
  };
};
